/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/Components/Common/FooterLinks" />
import React = require("react");
import * as Resources from "DistributedTaskUI/ServiceEndpoints/Editor/Resources";
import { Link } from "VSSUI/Link";

interface IFooterLinksProps {
    learnMoreLink: string;
    troubleShootlink: string;
}

export function FooterLinks(props: IFooterLinksProps): JSX.Element {
    return (<div className="connections-editor-panel-generic-footer-left">
        <Link
            className="links-connections"
            href={props.learnMoreLink}
            target="_blank"
            ariaLabel={Resources.LearnMoreTextAriaLabel}
        >
            {Resources.LearnMoreText}
        </Link>
        <Link
            className="links-connections link-secondary"
            href={props.troubleShootlink}
            target="_blank"
            ariaLabel={Resources.TroubleshootingTextAriaLabel}
        >
            {Resources.TroubleshootingText}
        </Link>
    </div>);
}
